<template>
  <b-container fluid>
    <b-card v-for="(paket,ix) in pakete" v-bind:key="paket.id" no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle="paket.id.toString()" variant="primary">{{ paket.name[$i18n.locale] }}</b-btn>
      </b-card-header>
      <b-collapse :id="paket.id.toString()" :visible="ix === 0" accordion="pakete" role="tabpanel">
        <!--
            <b-card :header="$t('Freigaben')" class="mb-3">
                <b-list-group>
                    <b-list-group-item v-for="freigabe in paket.freigaben">
                        {{ convertTime(freigabe.from) }} - {{ convertTime(freigabe.until) }}
                    </b-list-group-item>
                </b-list-group>
            </b-card>
            <b-card :header="$t('Daten')">
                <b-card-body v-html="$t('Datenpakete_KeineDaten')"></b-card-body>
            </b-card>
        -->
        <b-card-body v-html="$t('Datenpakete_KeineDaten')"></b-card-body>
      </b-collapse>
    </b-card>
  </b-container>
</template>

<script>
import moment from "moment";

export default {
  name: "paketdaten",
  data() {
    return {};
  },
  computed: {
    pakete() {
      return this.$store.state.datenpaketeStore.pakete.filter(function(item) {
        return item.freigaben.length > 0 && item.freigaben[0].bis === null;
      });
    }
  },
  methods: {
    convertTime(value) {
      return value.length > 0 ? moment(value).format("DD.MM.YYYY") : "";
    }
  },
  created() {
    this.$nextTick(async function() {
      //this.$store.dispatch("loadKriterien")
      this.$store.dispatch("loadPakete");
    });
  },
  mounted() {},
  updated() {},
  components: {}
};
</script>